import { FilterCheckbox } from "./FilterCheckbox";
import { HTMLAttributes, useRef } from "react";
import styled from "@emotion/styled";
import { flexBetween } from "config/commonCSS";
import { useHover } from "usehooks-ts";
import { useIsMobile } from "hooks/useDeviceType";

interface FilterOptionRowProps {
  onClick: () => void;
  checked: boolean;
  style?: HTMLAttributes<HTMLDivElement>["style"];
}

export const FilterOptionRow = ({
  onClick,
  checked,
  style,
  children,
}: React.PropsWithChildren<FilterOptionRowProps>) => {
  const rowRef = useRef<HTMLDivElement | null>(null);
  const isHover = useHover(rowRef);
  const isMobile = useIsMobile();

  return (
    <Container style={style} onClick={onClick} ref={rowRef} isMobile={isMobile}>
      {children}
      <FilterCheckbox checked={checked} isRowHoveredOn={isHover} />
    </Container>
  );
};

// Sub-components

const Container = styled.div<{ isMobile: boolean }>`
  ${flexBetween};
  cursor: pointer;
  border-radius: 14px;
  padding: ${props => (props.isMobile ? 16 : 11)}px 10px;
  font-size: ${props => (props.isMobile ? props.theme.fontSize[6] : props.theme.fontSize[5])};
  font-style: normal;
  line-height: ${props => props.theme.lineHeights[6]};

  &:hover {
    background-color: ${props => props.theme.surface.main.secondary.default};
    transition: background-color 250ms ease-in-out;
  }
`;
